import {
  InvisibleSmartCaptchaProps,
  SmartCaptchaProps,
  InvisibleSmartCaptcha as YandexInvisibleSmartCaptcha,
  SmartCaptcha as YandexSmartCaptcha,
} from '@yandex/smart-captcha';
import { useConfig } from '@cp/shared/config';

export const SmartCaptcha = (props: Omit<SmartCaptchaProps, 'sitekey'>) => {
  const config = useConfig();
  const siteKey = config.getOrThrow('YANDEX_SMART_CAPTCHA_KEY');
  return <YandexSmartCaptcha sitekey={String(siteKey)} {...props} />;
};

export const InvisibleSmartCaptcha = (props: Omit<InvisibleSmartCaptchaProps, 'sitekey'>) => {
  const config = useConfig();
  const siteKey = config.getOrThrow('YANDEX_SMART_CAPTCHA_KEY');
  return <YandexInvisibleSmartCaptcha sitekey={String(siteKey)} {...props} />;
};
